"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _types = require("./types");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = _interopRequireDefault(require("./styles"));
var _ThemeProvider = require("baseStyles/ThemeProvider");
var _useClickThrottle = require("hooks/useClickThrottle");
var _colors = require("baseStyles/enums/colors");
var _excluded = ["type", "children", "onClick", "icon", "timeout", "disabled", "dataTestId"];
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var getBackground = function getBackground(props, theme) {
  if (props.primary) return {
    backgroundColor: "#4F52C3",
    hover: {
      backgroundColor: "#34389F"
    }
  };
  if (props.secondary) return {
    backgroundColor: "#BDBFF9"
  };
  if (props.primaryFilled) return {
    backgroundColor: theme.primaryFillButton,
    hover: {
      backgroundColor: theme.primaryFillButtonHover
    }
  };
  if (props.secondaryFilled) return {
    backgroundColor: theme.secondaryFillButton,
    hover: {
      backgroundColor: theme.secondaryFillButtonHover
    }
  };
  if (props.bordered) return {
    backgroundColor: "transparent",
    border: "2px solid ".concat(_colors.Colors.PURE_PURPLE, " !important"),
    shadowWidth: 0.001,
    hover: {
      backgroundColor: "#9D9FFC33",
      border: "2px solid ".concat(_colors.Colors.NAVY_BLUE, " !important")
    }
  };
  return {
    backgroundColor: "#EDEDF9"
  };
};
var StyledButton = _styledComponents["default"].button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0;\n    border-radius: 800px;\n    box-shadow: ", ";\n    height: ", ";\n    padding: ", ";\n    background-color: ", ";\n    ", ";\n    border: ", ";\n    outline: 0;\n    box-sizing: border-box;\n    width: ", ";\n    transition: all 0.25s;\n    padding-bottom: ", "px;\n    padding-top: 0px;\n\n    :hover {\n        background-color: ", ";\n        cursor: ", ";\n        ", ";\n    };\n\n    :focus {\n        box-shadow: ", ";\n        padding-bottom: 0px;\n        padding-top: ", "px;\n    };\n    ", ";\n"])), function (props) {
  return "0px -".concat(props.shadowWidth || 6, "px 0px 0px rgba(0, 0, 0, 0.25) inset !important");
}, function (props) {
  return props.height;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.margin && "margin: ".concat(props.margin);
}, function (props) {
  return props.border || 0;
}, function (props) {
  return props.width || "100%";
}, function (props) {
  return props.shadowWidth;
}, function (props) {
  var _props$hover;
  return props === null || props === void 0 ? void 0 : (_props$hover = props.hover) === null || _props$hover === void 0 ? void 0 : _props$hover.backgroundColor;
}, function (props) {
  var _props$hover2;
  return props === null || props === void 0 ? void 0 : (_props$hover2 = props.hover) === null || _props$hover2 === void 0 ? void 0 : _props$hover2.cursor;
}, function (props) {
  var _props$hover3, _props$hover4;
  return (props === null || props === void 0 ? void 0 : (_props$hover3 = props.hover) === null || _props$hover3 === void 0 ? void 0 : _props$hover3.border) && "border: ".concat(props === null || props === void 0 ? void 0 : (_props$hover4 = props.hover) === null || _props$hover4 === void 0 ? void 0 : _props$hover4.border);
}, function (props) {
  return "0px ".concat(props.shadowWidth || 6, "px 0px 0px rgba(0, 0, 0, 0.25) inset !important");
}, function (props) {
  return props.shadowWidth;
}, function (props) {
  return "".concat((props === null || props === void 0 ? void 0 : props.disabled) && "\n        pointer-events: none;\n        opacity: 0.4;\n    ");
});
var Button = function Button(_ref) {
  var type = _ref.type,
    children = _ref.children,
    onClick = _ref.onClick,
    icon = _ref.icon,
    timeout = _ref.timeout,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    dataTestId = _ref.dataTestId,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = (0, _styles["default"])();
  var _useSuiTheme = (0, _ThemeProvider.useSuiTheme)(),
    theme = _useSuiTheme.theme;
  var background = getBackground(props, theme);
  var throttledOnClick = (0, _useClickThrottle.useClickThrottle)(onClick, timeout);
  return /*#__PURE__*/_react["default"].createElement(StyledButton, _extends({
    "data-test-id": dataTestId,
    onClick: throttledOnClick,
    className: "sui-button"
  }, styles[type] || styles.L, background, props, {
    disabled: disabled,
    "data-sentry-element": "StyledButton",
    "data-sentry-component": "Button",
    "data-sentry-source-file": "index.tsx"
  }), icon, children);
};
Button[_types.ButtonStylesType.XL] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Button, _extends({
    type: _types.ButtonStylesType.XL
  }, props));
};
Button[_types.ButtonStylesType.L] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Button, _extends({
    type: _types.ButtonStylesType.L
  }, props));
};
Button[_types.ButtonStylesType.M] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Button, _extends({
    type: _types.ButtonStylesType.M
  }, props));
};
Button[_types.ButtonStylesType.S] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Button, _extends({
    type: _types.ButtonStylesType.S
  }, props));
};
Button[_types.ButtonStylesType.XS] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Button, _extends({
    type: _types.ButtonStylesType.XS
  }, props));
};
var _default = Button;
exports["default"] = _default;